import { ReactNode } from "react";
import { useContentChannel } from "../../components";
import { MenuButton, Buttons, ButtonAppearance } from "capitalrx-components-2.0/lib/general";
import * as Color from "capitalrx-components-2.0/lib/general/Color";
import styles from "./Actions.module.css";

const CustomAppearance: ButtonAppearance = {
  ...Buttons.Functional.Tertiary.Large,
  padding: {
    horizontal: 12,
    vertical: 4,
  },
  label: {
    ...Buttons.Functional.Tertiary.Large.label,
    uppercase: false,
    weight: "regular",
    letterSpacing: 0,
    lineHeight: 24,
  },
  normal: {
    ...Buttons.Functional.Tertiary.Large.normal,
    foregroundColor: Color.White,
    textUnderline: false,
  },
  hover: {
    ...Buttons.Functional.Tertiary.Large.hover,
    foregroundColor: Color.White,
    backgroundColor: Color.withAlpha(Color.Turqoise["800"], 0.25),
    borderColor: Color.withAlpha(Color.White, 0.5),
    textUnderline: false,
  },
  pressed: {
    ...Buttons.Functional.Tertiary.Large.pressed,
    foregroundColor: Color.White,
    backgroundColor: Color.withAlpha(Color.White, 0.1),
    textUnderline: false,
  },
  disabled: {
    ...Buttons.Functional.Tertiary.Large.disabled,
    foregroundColor: Color.White,
    textUnderline: false,
  },
};

/** The container component for the menu bar actions. */
export const Actions = (): ReactNode => {
  const subscriptions = useContentChannel(null, "global-actions");

  return (
    <div className={`${styles.root} actions`}>
      {(subscriptions.length === 1) && (
        <>
          {subscriptions.map((subscription, index) => {
            const { component: Component } = subscription;
            return <Component key={index} />;
          })}
        </>
      )}
      {(subscriptions.length > 1) && (
        <MenuButton label="Account" appearance={CustomAppearance} tabIndex={5}>
          {subscriptions.map((subscription, index) => {
            const { component: Component } = subscription;

            return (
              <MenuButton.ComponentItem key={index} style={{ padding: 0 }}>
                <Component />
              </MenuButton.ComponentItem>
            );
          })}
        </MenuButton>
      )}
    </div>
  );
};
